/* jshint esversion: 6, -W097 */
/* globals require, module */
'use strict';

const commonModule = require('@utils/common/commonModule');
const googleMapsDirective = require('./googleMapsDirective');
const googleMapsSearchDirective = require('./search/googleMapsSearchDirective');
const googleApiService = require('./googleApiService');

const googleMapsModule = angular
    .module('enervee_utils.google_maps', [
        commonModule.name,
    ])
    .factory('GoogleApiService', googleApiService)
    .directive('googleMaps', googleMapsDirective)
    .directive('googleMapsSearch', googleMapsSearchDirective);

module.exports = googleMapsModule;
